<template>
    <div>
        <v-card flat ref="form" class="mt-0">
            <v-card-text class="pa-0 mb-4">
                <v-row>
                    <v-col cols="12" class="user-topbar">
                        <h2 class="step_title primary--text font-weight-regular">{{item.companyName}}</h2>
                        <v-btn rounded small class="ma-2 btn-edit-group" outlined color="#47266F" @click="toggleEdit" v-if="!isEditMode">
                            <v-icon v-text="'$edit'" color="#47266F" class="mr-1"></v-icon> Edit
                        </v-btn>
                        <v-spacer />
                        <!-- <v-btn text depressed v-if="item.isActive" style="color: #000;" ><v-icon class="mr-2 primary--text">fas fa-check-circle</v-icon> <span style="font-size: 13px; color: #828282; text-transform: none">{{$t('Make default')}}</span></v-btn>
                        <v-btn text depressed v-if="!item.isActive" style="color: #000;" :loading="isSetDefaultLoading" @click="setDefault"><v-icon class="mr-2 primary--text">far fa-circle</v-icon> <span style="font-size: 13px; color: #828282; text-transform: none">{{$t('Make default')}}</span></v-btn> -->
                    </v-col>
                    <v-col cols="6" class="py-0">
                        <ImagePickerInput v-model="item.logoFile" :image-placeholder="item.logoUrl" :disabled="!isEditMode"></ImagePickerInput>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text class="pa-0 mb-4">
                <v-row>
                    <v-col cols="6" class="py-0">
                        <p class="label">Société (Expéditeur)</p>
                        <v-text-field placeholder="" v-model="item.companyName" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col>

                    <v-col cols="6" class="py-0">
                        <p class="label">Adresse</p>
                        <v-text-field placeholder="" v-model="item.address" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text class="pa-0 mb-4">
                <v-row>
                    <!-- <v-col cols="6" class="py-0">
                        <p class="label">Nom du contact</p>
                        <v-text-field placeholder="" v-model="item.contactName" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col> -->
                    <v-col cols="6" class="py-0">
                        <p class="label">Ville</p>
                        <v-text-field placeholder="" v-model="item.city" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col>

                    <v-col cols="6" class="py-0">
                        <p class="label">Code postal</p>
                        <v-text-field placeholder="" v-model="item.codePostal" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
           <!--  <v-card-text class="pa-0 mb-4">
                <v-row>
                    <v-col cols="6" class="py-0">
                        <p class="label">Email</p>
                        <v-text-field placeholder="" v-model="item.email" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col>

                    
                </v-row>
            </v-card-text> -->
            <v-card-text class="pa-0 mb-4">
                <v-row>
                   <!--  <v-col cols="6" class="py-0">
                        <p class="label">Téléphone</p>
                        <v-text-field placeholder="" v-model="item.telephone" hide-details="auto" outlined required :disabled="!isEditMode"></v-text-field>
                    </v-col> -->

                    <v-col cols="6" class="py-0">
                        <p class="label">Pays</p>
                        <CountryPickerInput v-model="item.countryId" :disabled="!isEditMode"></CountryPickerInput>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text class="pa-0 mb-4">
                <v-row>
                    <v-col cols="12" class="py-0">
                        <p class="label">Footer</p>
                        <v-textarea
                                outlined
                                no-resize
                                rows="5"
                                v-model="item.description"
                                :disabled="!isEditMode"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <div class="text-center" v-if="isEditMode">
            <v-btn class="ma-2" depressed rounded color="primary" @click.prevent="save" :loading="isSaveLoading">{{$t('Save')}}</v-btn>
            <v-btn class="ma-2 black--text" depressed rounded color="#E1E1E1" @click.prevent="cancel">{{$t('Cancel')}}</v-btn>
        </div>
    </div>
</template>

<script>
  import CountryPickerInput from '@/components/inputs/CountryPickerInput.vue';
  import ImagePickerInput from '@/components/inputs/ImagePickerInput.vue';
  import IdentityService from '@/services/identity.service.js';

  export default {
    name: "IdentityItem",
    components: {
      CountryPickerInput,
      ImagePickerInput,
    },
    props: {
      value: {},
      id: {},
      index: {type: Number, default: 0}
    },
    data: () => ({
      isSaveLoading: false,
      isSetDefaultLoading: false,
      isEditMode: false,
      item: {}
    }),
    methods: {
      async save() {
        if (this.isSaveLoading) {
          return;
        }

        this.isSaveLoading = true;
        try {
          const {data} = await IdentityService.update(this.id, this.item);
          this.$emit('input', data);
          this.isEditMode = false;
        } catch (e) {
            this.handleError(e)
        }
        this.isSaveLoading = false;
      },
      cancel() {
        if (this.isSaveLoading) {
          return;
        }

        this.item = Object.assign({}, this.value);
        this.isEditMode = false;
      },
      async setDefault() {
        if (this.isSetDefaultLoading) {
          return;
        }

        this.isSetDefaultLoading = true;
        try {
          await IdentityService.setDefault(this.id);
          this.$emit('update:set-default', this.id);
        } catch (e) {
          this.handleError(e);
        }

        this.isSetDefaultLoading = false;
      },
      toggleEdit() {
        this.isEditMode = true;
      }
    },
    watch: {
      value: {
        deep: true,
        immediate: true,
        handler(value) {
          this.item = Object.assign({}, value);
        }
      }
    }
  }
</script>

<style scoped>

</style>
